import { api } from '../api';
import { GetTransactionDto, GetUserTransactionsDto, GetTableTransactionsDto } from './transactions-types';
import { TransactionResponseDto, AdminBulkTransferUser, TransactionType } from '@repo/common-types';
import { downloadBlobAsFile } from '@/common/utils/download-file';

export const getTransactionsRest = async (params: GetTransactionDto): Promise<TransactionResponseDto> => {
  const response = await api.get('v1/admin/transactions', {
    params: params,
  });

  return response.data;
};

export const getDepositStatsRest = async () => {
  const response = await api.get<any>(`/v1/admin/transactions/deposit-stats`);
  return response.data;
};

export const adminTransferRest = async (address: string | undefined, amount: number | undefined) => {
  const response = await api.post(`/v1/admin/user/admin-transfer`, {
    amount,
    address,
  });
  return response.data;
};

export const getUserTransactionsRest = async (userId: string, params: GetUserTransactionsDto) => {
  const response = await api.get(`/v1/admin/transactions/user/${userId}`, {
    params: params,
  });
  return response.data;
};

export const exportUserTransactionsCsvRest = async (userId: string): Promise<void> => {
  const response = await api.get(`/v1/admin/transactions/user/${userId}/export/csv`, {
    responseType: 'blob',
  });

  downloadBlobAsFile({
    blob: new Blob([response.data], { type: 'text/csv' }),
    filename: `user_transactions_${userId}.csv`,
  });
};

export const getTableTransactionsRest = async (tableId: string, params: GetTableTransactionsDto) => {
  const response = await api.get<any>(`/v1/admin/transactions/table/${tableId}`, {
    params,
  });
  return response.data;
};

export const adminWalletTransferRest = async (from: string, to: string, amount: number) => {
  const response = await api.post(`/v1/admin/transactions/wallet-transfer`, {
    from,
    to,
    amount,
  });
  return response.data;
};

export const retryTransactionRest = async (transactionId: string): Promise<void> => {
  await api.post(`/v1/admin/transactions/retry/${transactionId}`);
};

export const retryBulkTransactionsRest = async (
  transactionIds: string[],
): Promise<{
  succeeded: string[];
  failed: { transactionId: string; reason: string }[];
}> => {
  const response = await api.post(`/v1/admin/transactions/retry-bulk`, { transactionIds });
  return response.data;
};

export const getTransactionRetryStatus = async (
  transactionId: string,
): Promise<{
  canRetry: boolean;
  remainingCooldownSeconds?: number;
  message?: string;
}> => {
  const response = await api.get(`/v1/admin/transactions/retry-status/${transactionId}`);
  return response.data;
};

export const bulkAdminTransferRest = async (
  users: AdminBulkTransferUser[],
  transactionType: TransactionType,
  mfaCode?: string,
) => {
  const headers = mfaCode ? { 'x-totp-code': mfaCode } : undefined;

  const response = await api.post(
    `/v1/admin/user/bulk-admin-transfer`,
    {
      users,
      transactionType,
    },
    headers
      ? {
          headers,
        }
      : undefined,
  );
  return response.data;
};
